import {
  ArrowDownLeft,
  ArrowLeft,
  ArrowUpRight,
  BadgePercent,
  Banknote,
  BookOpenCheck,
  BriefcaseBusiness,
  CalendarDays,
  Check,
  CircleCheck,
  CircleDollarSign,
  CircleHelp,
  CircleX,
  ClipboardCheck,
  Clock3,
  Download,
  FileText,
  FileSpreadsheet,
  Filter,
  Eye,
  ExternalLink,
  House,
  Image,
  LogOut,
  Menu,
  Minus,
  TextAlignStart,
  TextAlignEnd,
  Trash2,
  Plus,
  Pencil,
  RefreshCw,
  RotateCcw,
  ReceiptText,
  Search,
  SearchX,
  Send,
  UserPlus,
  UserRoundCog,
  Users,
  UsersRound,
  Upload,
  WalletCards,
  X,
  Map,
  Paperclip,
  Save,
  UserRoundCheck,
  Undo2,
  History
} from 'lucide-angular';

export const lucideIcons = {
  ArrowDownLeft,
  ArrowLeft,
  ArrowUpRight,
  BadgePercent,
  Banknote,
  BookOpenCheck,
  BriefcaseBusiness,
  CalendarDays,
  Check,
  CircleCheck,
  CircleDollarSign,
  CircleHelp,
  CircleX,
  ClipboardCheck,
  Clock3,
  Download,
  FileText,
  FileSpreadsheet,
  Filter,
  Eye,
  ExternalLink,
  House,
  Image,
  LogOut,
  Menu,
  Minus,
  TextAlignEnd,
  TextAlignStart,
  Trash2,
  Plus,
  Pencil,
  RefreshCw,
  RotateCcw,
  ReceiptText,
  Search,
  SearchX,
  Send,
  UserPlus,
  UserRoundCog,
  Users,
  UsersRound,
  Upload,
  WalletCards,
  X,
  Map,
  Paperclip,
  Save,
  UserRoundCheck,
  Undo2,
  History
};
